"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_router_1 = require("react-router");
const qs_1 = require("qs");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const DeviceTransitionContainer_1 = require("../utils/DeviceTransitionContainer");
const OverviewModalHeader_1 = require("../wizards/overview/OverviewModalHeader");
const NotificationStatistics_1 = require("./NotificationStatistics");
const NotificationStatisticsGraph_1 = require("./NotificationStatisticsGraph");
const ReportPreview_1 = require("./ReportPreview");
const ExperienceReport_1 = require("./ExperienceReport");
class Report extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            ref: undefined,
        };
        this.postMessage = this.postMessage.bind(this);
        this.setState = this.setState.bind(this);
    }
    postMessage(message) {
        const { ref } = this.state;
        if (!ref) {
            return;
        }
        ref.contentWindow.postMessage(message, '*');
    }
    render() {
        const { device, location } = this.props;
        const { campaignId } = qs_1.parse(location.search.substring(1));
        return (React.createElement(DeviceTransitionContainer_1.default, { device: device },
            React.createElement(React.Fragment, null,
                React.createElement(OverviewModalHeader_1.default, { campaignId: campaignId, device: device, style: {
                        position: 'absolute',
                        top: 0,
                        transform: 'translate3d(0,0,0)',
                        zIndex: 1,
                    } }),
                React.createElement("div", { id: "reporting-scroll-container", style: {
                        height: '100%',
                        width: '100%',
                        backgroundColor: src_1.white,
                        overflowX: 'scroll',
                    } },
                    React.createElement("style", { dangerouslySetInnerHTML: {
                            __html: '#reporting-scroll-container::-webkit-scrollbar { display: none; }',
                        } }),
                    React.createElement(NotificationStatisticsGraph_1.default, { campaignId: campaignId, device: device }),
                    React.createElement("div", { style: {
                            paddingTop: 24,
                            marginBottom: `calc(100vh - 664px)`,
                        } },
                        React.createElement(NotificationStatistics_1.default, { campaignId: campaignId, device: device }),
                        React.createElement(ExperienceReport_1.default, { campaignId: campaignId, device: device, postMessage: this.postMessage })),
                    device === 'Desktop' && document.getElementById('phone-bezel') && (React.createElement(ReportPreview_1.default, { campaignId: campaignId, passRefToParent: (ref) => this.setState({ ref }) }))))));
    }
}
exports.default = react_router_1.withRouter(Report);
